<template>
  <nav
    ref="navBar"
    class="navbar-expand-lg bb-navbar p-2 px-4"
  >
    <div class="d-flex align-items-end mb-2">
      <!-- LOGO -->
      <img src="/bbLogo64Blue.png" />
      <router-link
        class="navbar-brand px-3 mb-1"
        :to="{ name: 'campaignsView' }"
      >
        <span class="fw-lighter bb-app-heading">BATTLEBOARD</span>
      </router-link>

      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav ms-auto mt-2 align-items-end">
          <!--------------->
          <!-- create PC -->
          <!--------------->
          <!-- <li class="nav-item active ms-4 me-4">
            <router-link class="nav-link" :to="{ name: 'playerCharacterSetup' }">
              Create Character
            </router-link>
          </li> -->
          <!------------>
          <!-- my PCs -->
          <!------------>
          <li class="nav-item ms-4 me-4">
            <router-link
              class="nav-link"
              :to="{ name: 'myCharactersView' }"
            >
              My Characters
            </router-link>
          </li>
          <!------------------->
          <!-- all campaigns -->
          <!------------------->
          <li class="nav-item active me-4">
            <router-link
              class="nav-link"
              :to="{ name: 'campaignsView' }"
            >
              All Campaigns
            </router-link>
          </li>
          <!------------------->
          <!-- my campaigns  -->
          <!------------------->
          <li class="nav-item ms-4 me-4">
            <router-link
              class="nav-link"
              :to="{ name: 'myCampaignsView' }"
            >
              My Campaigns
            </router-link>
          </li>
          <!------------------->
          <!-- create campaign -->
          <!------------------->
          <li class="nav-item active ms-4 me-4">
            <router-link
              class="nav-link"
              :to="{ name: 'campaignSetup' }"
            >
              Create Campaign
            </router-link>
          </li>
          <!------------------->
          <!-- dropdown      -->
          <!------------------->
          <li class="nav-item me-4">
            <a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNavDarkDropdown"
                aria-controls="navbarNavDarkDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div
                class="collapse navbar-collapse"
                id="navbarNavDarkDropdown"
              >
                <li class="nav-item dropdown">
                  <a>
                    <!-- dropdown-menu-dark -->
                    <button
                      class="btn dropdown-toggle btn-dark"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ userProfile.user_name }}
                    </button>
                    <ul class="dropdown-menu dropdown-menu-dark mt-0">
                      <!---------------------->
                      <!-- EDIT PROFILE     -->
                      <!---------------------->
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                        >
                          <router-link
                            class="nav-link"
                            :to="{ name: 'editProfileView' }"
                          >
                            Edit Profile
                          </router-link>
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                        >
                          <router-link
                            class="nav-link"
                            :to="{ name: 'changePasswordView' }"
                          >
                            Change Password
                          </router-link>
                        </a>
                      </li>
                      <!---------------------->
                      <!-- SUB-MENU (ABOUT) -->
                      <!---------------------->
                      <li class="submenu submenu-md dropend">
                        <a
                          class="dropdown-item dropdown-toggle"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onclick="event.stopPropagation();"
                        >
                          About
                        </a>
                        <!--------------------->
                        <!-- ITEM: VERSION   -->
                        <!--------------------->
                        <ul class="dropdown-menu">
                          <li>
                            <a class="dropdown-item">{{ getVersion }}</a>
                          </li>
                        </ul>
                      </li>
                      <!--------------------->
                      <!-- DIVIDER         -->
                      <!--------------------->
                      <div class="dropdown-divider"></div>
                      <!---------------------->
                      <!-- LOGOUT -->
                      <!---------------------->
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                        >
                          <router-link
                            class="nav-link"
                            :to="{ name: 'logoutView' }"
                          >
                            Logout
                          </router-link>
                        </a>
                      </li>
                    </ul>
                  </a>
                </li>
              </div>
            </a>
          </li>
          <!-- avatar -->
          <li class="nav-item me-2">
            <span class="d-inline-block">
              <img
                v-bind:src="userProfile.avatar_image"
                height="70"
                width="70"
                class="rounded-circle bb-img"
                alt="Avatar"
              />
            </span>
          </li>
          <!-- end items -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
// --------
// scripts
//---------
import { mapGetters } from 'vuex'
export default {
  name: 'NavbarComponent',
  mounted() {
    // const magiclinenav = document.createElement("script");
    // magiclinenav.setAttribute("type", "application/javascript");
    // magiclinenav.setAttribute("src", "./static/js/magic-line-nav.js");
    // document.head.appendChild(magiclinenav);
  },
  computed: {
    ...mapGetters('auth', {
      userProfile: 'getUserProfile',
    }),
    ...mapGetters('combat', {
      getVersion: 'getVersion',
    }),
  },
}
</script>
